export const copy = {
    text: function (value): void {
        const tempEl = document.createElement('textarea');
        tempEl.value = value;
        tempEl.style.position = 'fixed';
        tempEl.style.top = '-1000000px';

        document.body.appendChild(tempEl);
        tempEl.select();

        document.execCommand('copy');

        document.body.removeChild(tempEl);
    }
};
